import { AccentColorOptions } from 'epic-ue-theme';
import React from 'react';
import styled from 'styled-components';
import { getRadialGradient } from '../gradient/GradientWrapper';

const TextLinkWrapper = styled.span<{ accentColor?: AccentColorOptions; color: string }>`
    && a {
        color: ${(p) => p.theme.palette.common[p.color] || p.theme.palette.common.black};
        text-decoration: none;
        line-height: initial;
        background-image: ${(p) =>
        getRadialGradient(
            p.accentColor ? p.theme.palette.gradient[p.accentColor].from : p.theme.palette.common[p.color],
            p.accentColor ? p.theme.palette.gradient[p.accentColor].to : p.theme.palette.common[p.color]
        )};
        background-position: 0% 100%;
        background-repeat: no-repeat;
        background-size: 0% 2px;
        padding-bottom: 2px;
        margin-bottom: -2px;
        &:hover {
            color: ${(p) => p.theme.palette.common[p.color] || p.theme.palette.common.black};
            animation: underline 1.8s infinite;
            @media (prefers-reduced-motion: reduce) {
                animation: none;
                background-size: 100% 2px;
            }
            @keyframes underline {
                0% {
                    background-size: 10% 2px;
                }
                50% {
                    background-size: 100% 2px;
                }
                100% {
                    background-size: 100% 2px;
                }
            }
        }
        &:focus-visible {
            outline: 1px solid ${(p) => p.theme.palette.misc.outline};
            outline-offset: 2px;
        }
    }

    && a.ue-link-wrap:hover {
        color: ${(p) => p.theme.palette.common[p.color]};
        text-decoration: none;
    }
`;

interface TextWrapProps {
    accentColor?: AccentColorOptions;
    textColor?: 'black' | 'white';
    children: React.ReactNode;
}

export const TextLinkUnderlineWrap = ({
    accentColor = 'sky',
    textColor = 'black',
    children
}: TextWrapProps): JSX.Element => (
    <TextLinkWrapper accentColor={accentColor} color={textColor}>
        {children}
    </TextLinkWrapper>
);
